var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaffLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_-_Laff",
    "data-name": "logo - Laff",
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 50.853,
    viewBox: "0 0 82 50.853",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2025",
    "data-name": 2025
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M82,26.8l-.963-8.557-6.846.771-.514-4.565A1.4,1.4,0,0,1,74.893,12.7l5.451-.614L79.5,4.611l-8.3.935C65.43,6.2,63.259,9.714,63.865,15.1l.564,5.007-3.534.4.235-4.732-6.882-.341.228-4.588c.047-.956.588-1.567,1.48-1.523l5.48.272.373-7.517-8.346-.415c-5.8-.287-8.507,2.835-8.775,8.251l-.25,5.033-5.759-.286c-1.42-6.239-6.168-8.909-13.16-7.5C21.872,7.9,19.193,9.4,17.55,11.458L19.594,2.2,9.627,0,0,43.6l19.372,4.276,1.659-7.511a6.453,6.453,0,0,0,6.378,1.884c4.752-.961,6.084-4.029,5.335-9.019l1.416,7,9.114-1.844-.37,7.453,9.812.487,1.106-22.3,4.978.248.57,5.062,6.022-.677,2.5,22.186,9.761-1.1-2.5-22.187ZM22.315,24.149c-3.072,2.183-4.88,5.152-4.071,9.154l.379,1.875a12.719,12.719,0,0,0,1.2,3.459L11.932,36.9l3.88-17.57c.019.111.04.222.063.334l.569,2.813,9.316-1.884-.593-2.938a2.061,2.061,0,0,1,1.607-2.669,1.841,1.841,0,0,1,2.33,1.546l.165.813c.291,1.439-.458,2.24-2.007,3.27Zm8.1,8.934c-3.477,1.114-4.16-2.638-4.459-4.321.859,1.158,4.709.561,4.992-3.107l1.061,4.372a2.359,2.359,0,0,1-1.595,3.056m12.9,4.475L40.445,23.372l3.565.176Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaffLogo);
export default __webpack_public_path__ + "static/media/laff-logo.c51ce0e5902dd9bea3eb16597a7badf3.svg";
export { ForwardRef as ReactComponent };